$(document).on("click",".nav-link",function() {
   var attrnms = $(this).attr("href_url");
    if (typeof(attrnms) != "undefined")
    {
        window.location.href= attrnms;
    }
});

$(document).on("click",".hide-psw",function(){
  $(this).parent().find("input").attr("type","text");
  $(this).addClass("unhide-psw");    
  $(this).removeClass("hide-psw");  
});



$(document).on("click",".unhide-psw",function(){
  $(this).parent().find("input").attr("type","password");
  $(this).addClass("hide-psw");
   $(this).removeClass("unhide-psw");    
});



$(document).on("click",".main-acct-links .mb-item",function(){
  var index = parseInt($(this).attr("data-index"));
 $('.clk-btn[data-id="'+index+'"]').trigger("click");
});

$(document).on("click",".clk-btn",function(){
  $(".main-act-page").hide();
  $(".main-act-page-details").show();  
    $(".my-account-tabs .nav-tabs li a").removeClass("active");
    $(".my-account-tabs .nav-tabs li").eq(parseInt($(this).attr("data-id"))).find("a").addClass("active");
    $(".my-account-tabs .nav-tabs li").eq(parseInt($(this).attr("data-id"))).find("a").attr("aria-selected","true"); 
    $(".my-account-tabs .nav-tabs li").eq(parseInt($(this).attr("data-id"))).trigger("click");
   $(".ins-pc .tab-pane").removeClass("show");
$(".ins-pc .tab-pane").removeClass("active");
$(".ins-pc .tab-pane").eq(parseInt($(this).attr("data-id"))).addClass("active");
$(".ins-pc .tab-pane").eq(parseInt($(this).attr("data-id"))).addClass("show");

    $('html, body').animate({
        scrollTop: $("body").offset().top
    }, 1);
  
});

$(document).on("click",".bck-btn",function(){
  $(".main-act-page-details").hide();  
    $(".main-act-page").show();
  
});
function change_tab(tab_id){

   // // $(".nav-link").attr("class","nav-link");//clear classes
   // // $(".tab-pane").attr("class","tab-pane fade");//clear classes

   // var tab_content = "#"+tab_id;
   // var tab = "#"+tab_id+"-tab";
   // $(tab).attr("class","nav-link active show");
   // $(tab_content).attr("class"," tab-pane fade active show");
}


$(".main_item-hover").hover(function () {
        $(".bike_corral_pdp").hide();
        $(".bike_corral_pdp_hover").show();
    }, function () {
        $(".bike_corral_pdp_hover").hide();
        $(".bike_corral_pdp").show();
    });

$(document).on("click",".navbar-nav .nav-link",function(){
   var idx = $(this).index();
    if ($(".navbar-nav .tab-content .tab-pane").eq(idx).hasClass("show")) {
          if (typeof( $(this).attr("data-url")) != "undefined")
          {
      window.location.href = $(this).attr("data-url");
          }
    }   

});

$(document).on("click",".menu-outer .nav-link",function(){
  $('.menu-outer .nav-link').removeClass('active');
  $(this).addClass('active');
});

$(document).on("click",".pg-documents .nav-tabs li",function(){
$('.accordion-button[aria-expanded="true"]').trigger("click");
});

$(document).on("click",".recent-card",function() {
window.location.href = $(this).attr("data-url"); 
});
$(document).on("click",".filters-tab .all-filters p",function() {
var vislen = $(".all-filters-btns:visible").length;  
$(".all-filters-btns").slideToggle();  
$(this).parent().toggleClass("act");  
});
$(document).on("click",".filters-tab .all-filters svg",function() {
var vislen = $(".all-filters-btns:visible").length;  
$(".all-filters-btns").slideToggle();  
$(this).parent().toggleClass("act");  
});
$(document).on("click",".without_btn .all-filters-btns button",function() {
 var index = parseInt($(this).attr("data-index"));
 $(".all-filters-btns button").removeClass("active");
 $(this).addClass("active"); 
 $(".mob-none ul li").eq(index).find(".nav-link").trigger("click");
 $(".filters-tab .all-filters").parent().toggleClass("act");  
 $(".all-filters-btns").slideToggle();  
 
});

$(document).on("click",".with_btn .all-filters-btns button",function() {
 $(".all-filters-btns button").removeClass("active");
 $(this).addClass("active");  
});
$(document).on("click",".with_btn .fil-sub",function() {
var index = parseInt($(".sub-all-btns .active").attr("data-index"));
 $(".mob-none ul li").eq(index).find(".nav-link").trigger("click");
 $(".filters-tab .all-filters").parent().toggleClass("act");  
 $(".all-filters-btns").slideToggle();  
  
});


$(document).on("click",".rm_an",function() {
 $(".lal").removeClass("act_lunch");
});

$(document).on("click",".lal .hd",function() {
  $(this).parent().toggleClass("act_lunch");
    $("body").toggleClass("animate_act");

  //$(this).parent().find(".banner-button.act_btn").slideDown();  
  
});


$(document).on("click",".mb-search",function() {

$(".menu-drawer__utility-links").hide();  
$(".only_mb").slideUp('400');
 setTimeout(function(){ 
$(".main-srch").show();
  }, 600);  

});

$(document).on("click","header-drawer .header__icon",function() {
 var at_exist =$(this).parent().attr('open');
 if (typeof at_exist !== 'undefined' ) {
$(".menu-drawer__utility-links").show();  
$(".only_mb").show();
$(".main-srch").hide();
 }
});

// $(document).on("click","header-drawer",function() {
// $(".menu-drawer__utility-links").show();  
// $(".only_mb").show('400');
// $(".main-srch").hide();
// });


$(document).on("click",".edit_info_pass",function() {
    $(this).parents(".tab-content-inner").removeClass("unedit-info-pass");
    $(this).parents(".tab-content-inner").addClass("edit-info-f");
    $(this).addClass("editable");
});

$(document).on("click",".edit_info",function() {
    $(this).parents(".tab-content-inner").removeClass("unedit-info");
        $(this).parents(".tab-content-inner").addClass("edit-info-f");
    $(this).addClass("editable");
});
$(document).on("click",".edit_info_add",function() {
    $(this).parents(".tab-content-inner").removeClass("unedit-info-add");
        $(this).parents(".tab-content-inner").addClass("edit-info-f-add");
    $(this).addClass("editable_add");
});
$(document).on("click",".rmv-btn",function() {
    $("body").addClass("ovact");
    $('#overlay-rmv').css("display","flex");  
});
$(document).on("click",".close-pop",function() {
   $("body").removeClass("ovact");
    $('#overlay-rmv').css("display","none");
});

$(document).on("click",".dlt",function() {
     var id = $(".save_info_pass").attr("data-id");
      $.ajax({
    type: 'POST',
    url: '/apps/customer/remove_customer.php',
    data: {
    cid: id    
    },
    dataType: 'json', 
    success: function (data) { 
     location.reload();
    } 
    }); 
});


$(document).on("click",".save_info_pass",function() {
 var main_pass = $("#pass-new").val();
 var c_main_pass = $("#c-pass-new").val();
  if(main_pass != '' && c_main_pass != ''){
 if(main_pass == c_main_pass){
              $(this).parents(".tab-content-inner").find(".all_error").html('<p></p>');
             $(this).parents(".tab-content-inner").find(".all_error").hide();
   var id = $(this).attr("data-id");
    $.ajax({
    type: 'POST',
    url: '/apps/customer/pw_update.php',
    data: {
    cid: id,
    pass:main_pass  
    
    },
    dataType: 'json', 
    success: function (data) { 
     location.reload();
    } 
    }); 
   
 }
  else{
           $(this).parents(".tab-content-inner").find(".all_error").html('<p>Please check password and confirm password</p>');
        $(this).parents(".tab-content-inner").find(".all_error").show();
  }
  }
  else{
        $(this).parents(".tab-content-inner").find(".all_error").html('<p>Please check password and confirm password</p>');
        $(this).parents(".tab-content-inner").find(".all_error").show();
  }
  
});


$(document).on("click",".save_info_add",function() {
 var name = $(".edit-info-f-add #fullname").val();
 var cid  = $(".cus_id").attr("data-id");
 var add_id = $(".cus_id").attr("add-id");
     $.ajax({
    type: 'POST',
    url: '/apps/customer/cus_add_update.php',
    data: {
    fn: name,
    city: $(".edit-info-f-add #city").val(),  
    zipcode: $(".edit-info-f-add #zipcode").val(), 
    add_f: $(".edit-info-f-add #street-1").val(), 
    state: $(".edit-info-f-add #state").val(),  
    country: $(".edit-info-f-add #country").val(), 
    add_l: $(".edit-info-f-add #street-2").val(),   
    add_id: add_id,
    cid: cid
    },
    dataType: 'json', 
    success: function (data) { 

       if(data.status == 'success'){
      $(".edit_info_add").parents(".tab-content-inner").addClass("unedit-info-add");
      $(".edit_info_add").parents(".tab-content-inner").removeClass("edit-info-f-add");
     $(".edit_info_add").removeClass("editable_add");
       $(".all_error_add").hide();
    }
else{
var nres = JSON.parse(data.res);
for(var k in nres.errors) {
var res = '<p>'+k+' '+nres.errors[k][0]+'</p>';
}
$(".all_error_add").html(res);
$(".all_error_add").show();

}  
   
    } 
    }); 

  
});

$(document).on("click",".save_info",function() {
  var fname = $(".edit-info-f #first-name").val();
  var lname = $(".edit-info-f #last-name").val();
  var email = $(".edit-info-f #username").val();
  var phn =  $(".edit-info-f #phone").val();
    $.ajax({
    type: 'POST',
    url: '/apps/customer/customer_update.php',
    data: {
    fn: fname,
    ln: lname,
    email: email,
    phn: phn,
    cid: $(".cus_id").attr("data-id")  
    },
    dataType: 'json', 
    success: function (data) { 
    if(data.status == 'success'){
      $(".edit_info").parents(".tab-content-inner").addClass("unedit-info");
      $(".edit_info").parents(".tab-content-inner").removeClass("edit-info-f");
     $(".edit_info").removeClass("editable");
       $(".all_error").hide();
    }
    else{
      var nres = JSON.parse(data.res);
     
      for(var k in nres.errors) {
       var res = '<p>'+k+' '+nres.errors[k][0]+'</p>';
        
}
      $(".all_error").html(res);
      $(".all_error").show();
      
    }  
    
    } 
    }); 
});


$(document).on("click",".lg_Out",function() {
var url = $(this).attr("href");
window.location.href = url;  
});

  $(document).on("click",".swatch_main_wrap_in.color img",function() {
    var didx = parseInt($(this).attr("data-index"));
    var curridx = parseInt($(this).attr("data-curr"));
    $("variant-radios fieldset").eq(didx).find("input").eq(curridx).trigger("click");
    $(this).parents(".swatch_main_wrap_in.color").find(".img_clrs").removeClass("checked_op");
    $(this).parent().addClass("checked_op");
     var foo = getParameterByName('variant'); // "lorem"
     var sku = $(".all_ids a[data-id='"+foo+"']").attr("data-sku");
     var prices = $(".all_ids a[data-id='"+foo+"']").attr("data-price");
    if($(".request_btn").length > 0){
     $(".request_btn").attr("data-sku",sku);
     $(".request_btn").attr("data-price",prices); 
    } 
update_slider();
    
});

$(document).on("click",".swatch_main_wrap_in.color p",function() {
    $(this).prev().find("img").trigger("click");
});

$(document).on("click",".contact_link",function() {
  if ($(this).hasClass("contact_link_eros")) {
  }
  else{
  window.location.href = '/pages/contact-us';
  }
});


$("ul.list-unstyled-swt").on("click", ".init", function() {
    $(this).closest("ul.list-unstyled-swt").children('li:not(.init)').toggle();
   $(this).toggleClass("act_li");

});
$(document).on("click",".feat h2",function() {
  $(this).parent().toggleClass("act_feat");
   $(this).parent().find(".feat-desc").slideToggle(); 
});



$("ul.list-unstyled-swt").on("click", "li:not(.init)", function() {
    var allOptions = $(this).parent("ul").children('li:not(.init)');
    allOptions.removeClass('selected');
    $(this).addClass('selected');
    $(this).parent("ul").children('.init').html($(this).html());
    allOptions.toggle();
   var didx = parseInt($(this).attr("data-index"));
    var curridx = parseInt($(this).attr("data-curr"));
    $("variant-radios fieldset").eq(didx).find("input").eq(curridx).trigger("click");
     $(this).parent("ul").children('.init').toggleClass("act_li");
   var foo = getParameterByName('variant'); // "lorem"
     var sku = $(".all_ids a[data-id='"+foo+"']").attr("data-sku");
     var prices = $(".all_ids a[data-id='"+foo+"']").attr("data-price");
    if($(".request_btn").length > 0){
     $(".request_btn").attr("data-sku",sku);
     $(".request_btn").attr("data-price",prices); 
    }

update_slider();
      if($('body').hasClass('custom_class_vertical-bike-rack')){
    var check_selected = parseInt($(".swatch_main_wrap_in.bike.capacity li.selected").attr('data-value'));
  if(check_selected == 5 || check_selected == 10 ){
$(".swatch_main_wrap_in.bike.spacing li[data-value='15-18']").addClass('hidden');
$(".swatch_main_wrap_in.bike.spacing li").addClass('only_element');
  var get_value = $(".swatch_main_wrap_in.bike.spacing li.only_element[data-curr='1']").html();
$(".swatch_main_wrap_in.bike.spacing li").removeClass('selected');
   var didx = parseInt($(".swatch_main_wrap_in.bike.spacing li.only_element[data-curr='1']").attr("data-index"));
    var curridx = parseInt($(".swatch_main_wrap_in.bike.spacing li.only_element[data-curr='1']").attr("data-curr"));
    $("variant-radios fieldset").eq(didx).find("input").eq(curridx).trigger("click");

$(".swatch_main_wrap_in.bike.spacing li.only_element[data-curr='1']").addClass('selected');
$(".swatch_main_wrap_in.bike.spacing li.init.only_element").html(get_value);
}else{
$(".swatch_main_wrap_in.bike.spacing li[data-value='15-18']").removeClass('hidden');
$(".swatch_main_wrap_in.bike.spacing li").removeClass('only_element');

}
      }
    if($('body').hasClass('custom_class_stretch-rack')){
    var check_selected = parseInt($(".swatch_main_wrap_in.bike.capacity li.selected").attr('data-value'));
  if(check_selected == 6 ){
$(".swatch_main_wrap_in.frame.size li").removeClass('hidden');

$(".swatch_main_wrap_in.frame.size li[data-curr='1']").addClass('hidden');
$(".swatch_main_wrap_in.frame.size li").addClass('only_element');
  var get_value = $(".swatch_main_wrap_in.frame.size li.only_element[data-curr='0']").html();
$(".swatch_main_wrap_in.frame.size li").removeClass('selected');
   var didx = parseInt($(".swatch_main_wrap_in.frame.size li.only_element[data-curr='0']").attr("data-index"));
    var curridx = parseInt($(".swatch_main_wrap_in.frame.size li.only_element[data-curr='0']").attr("data-curr"));
    $("variant-radios fieldset").eq(didx).find("input").eq(curridx).trigger("click");

$(".swatch_main_wrap_in.frame.size li.only_element[data-curr='0']").addClass('selected');
$(".swatch_main_wrap_in.frame.size li.init.only_element").html(get_value);
 
}else if(check_selected == 10){
$(".swatch_main_wrap_in.frame.size li").removeClass('hidden');

$(".swatch_main_wrap_in.frame.size li[data-curr='0']").addClass('hidden');
$(".swatch_main_wrap_in.frame.size li").addClass('only_element');
  var get_value = $(".swatch_main_wrap_in.frame.size li.only_element[data-curr='1']").html();
$(".swatch_main_wrap_in.frame.size li").removeClass('selected');
   var didx = parseInt($(".swatch_main_wrap_in.frame.size li.only_element[data-curr='1']").attr("data-index"));
    var curridx = parseInt($(".swatch_main_wrap_in.frame.size li.only_element[data-curr='1']").attr("data-curr"));
    $("variant-radios fieldset").eq(didx).find("input").eq(curridx).trigger("click");

$(".swatch_main_wrap_in.frame.size li.only_element[data-curr='1']").addClass('selected');
$(".swatch_main_wrap_in.frame.size li.init.only_element").html(get_value);
 
  }else{
$(".swatch_main_wrap_in.frame.size li").removeClass('hidden');
$(".swatch_main_wrap_in.frame.size li").removeClass('only_element');

}

      }
});



function update_slider(){
  if ($("body").hasClass("color_not_exist")) {
var viid  = getParameterByName('variant');
var selected_id  = $(".selected_var_id").attr("selected_var_id");
console.log(viid);
if(viid != null){
var data_alt = $(".all_ids a[data-id='"+viid+"']").attr("data-alt");
}else{
var data_alt = $(".all_ids a[data-id='"+selected_id+"']").attr("data-alt");
}
     console.log(data_alt);
   if(data_alt == ''){
        var main_slider= '';
var nav_slider= '';
main_slider +='<div class="slider-for">';
nav_slider +='<div class="slider-nav">';

$(".thumbnail-list li").each(function(){
var indexs  = $(this).index();
if (!$(this).hasClass("thumbnail-list_item--variant") || indexs == 0) {
   var imgsrc= $(this).find("button img").attr("src");
      var myArray = imgsrc.split("?");
      if ( $(this).find("button").hasClass("media-video")) {
      }
      else{
      main_slider +='<div class="product-image"><img src="'+myArray[0]+'" ></div>';
      nav_slider +='<div class="product-image thumb-img"><img src="'+myArray[0]+'" ></div>'; 
      }

}  
});
$(".thumbnail-list li").each(function(){
   var imgsrc= $(this).find("button img").attr("src");
      var myArray = imgsrc.split("?");
      if ( $(this).find("button").hasClass("media-video")) {
        var current_index = $(this).find("button").attr("data-path");
         main_slider +='<div class="product-image video_slide"><video controls><source src="'+current_index+'" type="video/mp4"></div>';
         nav_slider +='<div class="product-image thumb-img"><img src="'+myArray[0]+'" ><div class="play-button"><svg class="play-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="48" height="48" fill="white"><polygon points="24,16 24,48 48,32" /></svg></div></div>'; 
      }
});    
main_slider +='</div>';
nav_slider +='</div>';
   }else{
 var main_slider= '';
var nav_slider= '';
main_slider +='<div class="slider-for">';
nav_slider +='<div class="slider-nav">';
    
    $(".all_ids_pimgs img[alt='"+data_alt+"']").each(function(){
    var src = $(this).attr("src");
     main_slider +='<div class="product-image"><img src="'+src+'" ></div>';
   nav_slider +='<div class="product-image thumb-img"><img src="'+src+'" ></div>'; 
    }); 
$(".thumbnail-list li").each(function(){
   var imgsrc= $(this).find("button img").attr("src");
      var myArray = imgsrc.split("?");
      if ( $(this).find("button").hasClass("media-video")) {
        var current_index = $(this).find("button").attr("data-path");
         main_slider +='<div class="product-image video_slide"><video controls><source src="'+current_index+'" type="video/mp4"></div>';
         nav_slider +='<div class="product-image thumb-img"><img src="'+myArray[0]+'" ><div class="play-button"><svg class="play-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="48" height="48" fill="white"><polygon points="24,16 24,48 48,32" /></svg></div></div>'; 
      }
});
main_slider +='</div>';
nav_slider +='</div>';
   }
   
$(".container-slider").html(main_slider+nav_slider);
  if($(".slider-nav .product-image").length == 1){
  $(".slider-nav").hide();
}

   $('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: false,
    speed: 400,   
      infinite: false,   
  asNavFor: '.slider-nav',
   prevArrow:"<img class='img_lft' src='https://cdn.shopify.com/s/files/1/0685/4662/5750/files/Left-Arrow.svg?v=1710839853'>",
  nextArrow:"<img class='img_rt' src='https://cdn.shopify.com/s/files/1/0685/4662/5750/files/Right-arrow.svg?v=1710839853'>",
   responsive: [
    {
      breakpoint: 767,
      settings: {
        prevArrow:"<img class='img_lft' src='https://cdn.shopify.com/s/files/1/0685/4662/5750/files/Left-Arrow-mob.svg?v=1710848084'>",
       nextArrow:"<img class='img_rt' src='https://cdn.shopify.com/s/files/1/0685/4662/5750/files/Right-Arrow-mob.svg?v=1710848084'>"
      },
    },
  ]   
    
});
$('.slider-nav').slick({
slidesToShow: 5,
slidesToScroll: 1,
asNavFor: '.slider-for',
dots: false,
arrows: false,
infinite: false,   
focusOnSelect: true,
draggable: false,
swipeToSlide: false,
touchMove: false,
swipe:false  
});
  }
  else{
     var viid  = $(".product-variant-id").val();
     var data_alt = $(".all_ids a[data-id='"+viid+"']").attr("data-alt");
    
    var main_slider= '';
var nav_slider= '';
main_slider +='<div class="slider-for">';
nav_slider +='<div class="slider-nav">';
    
    $(".all_ids_pimgs img[alt='"+data_alt+"']").each(function(){
    var src = $(this).attr("src");
     main_slider +='<div class="product-image"><img src="'+src+'" ></div>';
   nav_slider +='<div class="product-image thumb-img"><img src="'+src+'" ></div>'; 
    }); 
$(".thumbnail-list li").each(function(){
   var imgsrc= $(this).find("button img").attr("src");
      var myArray = imgsrc.split("?");
      if ( $(this).find("button").hasClass("media-video")) {
        var current_index = $(this).find("button").attr("data-path");
         main_slider +='<div class="product-image video_slide"><video controls><source src="'+current_index+'" type="video/mp4"></div>';
         nav_slider +='<div class="product-image thumb-img"><img src="'+myArray[0]+'" ><div class="play-button"><svg class="play-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="48" height="48" fill="white"><polygon points="24,16 24,48 48,32" /></svg></div></div>'; 
      }
});
main_slider +='</div>';
nav_slider +='</div>';
$(".container-slider").html(main_slider+nav_slider);
  if($(".slider-nav .product-image").length == 1){
  $(".slider-nav").hide();    
}

   $('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: false,
    speed: 400,   
      infinite: false,   
  asNavFor: '.slider-nav',
   prevArrow:"<img class='img_lft' src='https://cdn.shopify.com/s/files/1/0685/4662/5750/files/Left-Arrow.svg?v=1710839853'>",
  nextArrow:"<img class='img_rt' src='https://cdn.shopify.com/s/files/1/0685/4662/5750/files/Right-arrow.svg?v=1710839853'>",
   responsive: [
    {
      breakpoint: 767,
      settings: {
        prevArrow:"<img class='img_lft' src='https://cdn.shopify.com/s/files/1/0685/4662/5750/files/Left-Arrow-mob.svg?v=1710848084'>",
       nextArrow:"<img class='img_rt' src='https://cdn.shopify.com/s/files/1/0685/4662/5750/files/Right-Arrow-mob.svg?v=1710848084'>"
      },
    },
  ]   
    
});
$('.slider-nav').slick({
slidesToShow: 5,
slidesToScroll: 1,
asNavFor: '.slider-for',
dots: false,
arrows: false,
infinite: false,   
focusOnSelect: true,
draggable: false,
swipeToSlide: false,
touchMove: false,
swipe:false  
});
    
    
    
  }
}


  

// $(document).on("click",".product-card .product-img img",function() {
//  var url = $(this).attr("data-url");
//  window.location.href =url;  
// });
// Function to set a cookie
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
}

// Function to get a cookie
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(nameEQ) === 0) {
            return decodeURIComponent(c.substring(nameEQ.length));
        }
    }
    return null;
}

// Function to safely parse JSON from cookies
function getParsedCookie(name) {
    var cookieValue = getCookie(name);
    if (!cookieValue) return []; // Return empty array if no cookie found

    try {
        return JSON.parse(cookieValue);
    } catch (e) {
        console.error("Error parsing JSON from cookie:", e.message);
        return []; // Return empty array if JSON parsing fails
    }
}

function checkCookie() {
  let user = getCookie("username");
  if (user != "") {
  } else {
    user = prompt("Please enter your name:", "");
    if (user != "" && user != null) {
      setCookie("username", user, 365);
    }
  }
}


$(document).on("click",".remove_quote",function() {
  var pid = $(this).prev().attr("data-sku");
  var raq = getCookie('raq');  
  var jsonobj =  getParsedCookie('raq');
   var jsonobj_n = [];
  var counter = 0;
    for (var i = 0; i < jsonobj.length; i++) {
     if(pid ==  jsonobj[i]['sku'])
     {
       counter++;
      var item= {}
          item['sku'] = jsonobj[i]['sku'];
          item['id'] = jsonobj[i]['id'];  
          item['pid'] = jsonobj[i]['pid'];    
          item['price'] = jsonobj[i]['price'];  
          item['imgsrc'] = jsonobj[i]['imgsrc'];  
          item['quantity'] = parseInt(jsonobj[i]['quantity'])+1;  
          item['ptitle'] = jsonobj[i]['ptitle'];   

          jsonobj_n.push(item);  
     }
      else{
          var item= {}
          item['sku'] = jsonobj[i]['sku'];
          item['id'] = jsonobj[i]['id'];  
          item['pid'] = jsonobj[i]['pid'];    
          item['price'] = jsonobj[i]['price'];  
          item['imgsrc'] = jsonobj[i]['imgsrc'];  
          item['quantity'] = jsonobj[i]['quantity'];  
          item['ptitle'] = jsonobj[i]['ptitle'];   

          jsonobj_n.push(item);  
       
        
      }
   
    }
    if(counter == 0){
      $(this).prev().trigger("click");
    }
  else{
     var myJSON = JSON.stringify(jsonobj_n);
          setCookie('raq', myJSON, 365);
   window.location.href = '/pages/request-a-quote';
  }


});

$(document).on("click",".request_btn",function() {
var raq = getCookie('raq');  
if(raq == ''){
var raq = getParsedCookie('raq'); // Get existing items (if any)

    var sku = $(this).attr("data-sku");
    var newItem = {
        sku: sku,
        id: $(this).attr("data-id"),
        pid: $(this).attr("data-pid"),
        price: $(this).attr("data-price"),
        imgsrc: $(this).attr("data-img"),
        ptitle: $(this).attr("data-title"),
        quantity: 1
    };

    raq.push(newItem); // Add new item to array

    var myJSON = JSON.stringify(raq);
    setCookie('raq', myJSON, 365); // Store updated JSON in cookie

    console.log("Updated JSON stored in cookie:", myJSON);
window.location.href = '/pages/request-a-quote';
}
else{
  var jsonobj = getParsedCookie('raq');
 var sku = $(this).attr("data-sku");
var item= {}
item['sku'] = sku;  
item['id'] = $(this).attr("data-id");  
item['pid'] = $(this).attr("data-pid");      
item['price'] = $(this).attr("data-price");  
item['imgsrc'] = $(this).attr("data-img");  
item['ptitle'] = $(this).attr("data-title");      
item['quantity'] = 1;  

jsonobj.push(item);  
var myJSON = JSON.stringify(jsonobj);
setCookie('raq', myJSON, 365);
window.location.href = '/pages/request-a-quote';
}  

});

$(document).on("click",".story-btn",function() {
$(".brands-story").addClass("fullsection");
var hgt = $(".brands-story .row").height();
$(".brands-story").height(hgt);  
});

$(document).on("click",".sch_new",function() {
$(".pred_seacrch").toggle();
});
$(document).on("click",".forgrt_link",function() {
$(".staraight-login").hide();
$(".forget-passw").show();  
});
$(document).on("click",".cancel-req",function() {
$(".forget-passw").hide();  
$(".staraight-login").show();
  
});

$(document).on("click",".cstm-btn",function() {
  var email = $(".create-account input[type='email']").val();
  var pass = $(".create-account input[type='password']").val();
  var pass_length = $(".create-account input[type='password']").val().length;
  var i = 0;
  if(email == ''){
    $(".create-account input[type='email']").parent().addClass("error-state");
    $(".emer").show();
   i++;
  }
  else{
     $(".create-account input[type='email']").parent().removeClass("error-state");
    $(".emer").hide();
  }
  var result =  validateEmail(email);
    if(result === false){
     $(".create-account input[type='email']").parent().addClass("error-state");
     $(".emer").show();
      i++;
    }
   else{
     $(".create-account input[type='email']").parent().removeClass("error-state");
    $(".emer").hide();
  }

  if(pass_length <  5){
     $(".create-account input[type='password']").parent().addClass("error-state");
    $(".passers").show();
      i++;
  }
  else{
    $(".create-account input[type='password']").parent().removeClass("error-state");
    $(".passers").hide();
  }
  if(i == 0){
   $(".create-account form").submit();
  }
  
});


  function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}


if (window.location.href.indexOf("recover") > -1) {
      $(".staraight-login").hide();
      $(".forget-passw").show(); 
    }
var counter = $(".forget-passw .form__message").length;
if(counter > 0){
    $(".staraight-login").hide();
      $(".forget-passw").show(); 
}



$(document).on("click",".col-add",function() {
var viid = $(this).attr("varid");  
if (typeof(viid) != "undefined"){
 // $('html, body').animate({
 //        scrollTop: $('body').offset().top - 20 //#DIV_ID is an example. Use the id of your destination on the page
 //    }, 'fast');  
$("#product-form-featured-product .product-variant-id").val(viid);
$("#product-form-featured-product .product-form__submit").trigger("click");  
}
});





$(document).on("click",".main_s_btn .scclk",function() {
  if($(".main_s_btn #Search").val() != ''){
  var search_keyword = $(".main_s_btn #Search").val();
$(".main_s_btn input[type='search']").val(search_keyword);  
  $(".pred_seacrch form").submit();
  }
});

$(document).on("click",".nwsltr",function() {
var f_3= $(".fts .mail-input").val();
var result =  validateEmail(f_3);
if(result === false){
$(".newsletter-form__message--error").show();
}
else{
$(".newsletter-form__field-wrapper .field__input").val(f_3);
$(".newsletter-form__field-wrapper .newsletter-form__button").trigger("click");
}   
  
});

 function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
var foo = getParameterByName('customer_posted'); // "lorem"
if(foo == 'true'){
  $(".newsletter-form__message--success").show();
}




$(document).ready(function(){
if (window.location.href === "https://sarisinfrastructure.com/products" || window.location.href === "https://sarisinfrastructure.com/products/") {
    window.location.href = "/";
}

  if($('body').hasClass('custom_class_vertical-bike-rack')){
    var check_selected = parseInt($(".swatch_main_wrap_in.bike.capacity li.selected").attr('data-value'));
  if(check_selected == 5 || check_selected == 10 ){
$(".swatch_main_wrap_in.bike.spacing li[data-value='15-18']").addClass('hidden');
$(".swatch_main_wrap_in.bike.spacing li").addClass('only_element');
   var didx = parseInt($(".swatch_main_wrap_in.frame.size li.only_element[data-curr='1']").attr("data-index"));
    var curridx = parseInt($(".swatch_main_wrap_in.frame.size li.only_element[data-curr='1']").attr("data-curr"));
    $("variant-radios fieldset").eq(didx).find("input").eq(curridx).trigger("click");

}else{
$(".swatch_main_wrap_in.bike.spacing li[data-value='15-18']").removeClass('hidden');
$(".swatch_main_wrap_in.bike.spacing li").removeClass('only_element');

}
      }
    if($('body').hasClass('custom_class_stretch-rack')){
    var check_selected = parseInt($(".swatch_main_wrap_in.bike.capacity li.selected").attr('data-value'));
  if(check_selected == 6 ){
$(".swatch_main_wrap_in.frame.size li").removeClass('hidden');

$(".swatch_main_wrap_in.frame.size li[data-curr='1']").addClass('hidden');
$(".swatch_main_wrap_in.frame.size li").addClass('only_element');
  var get_value = $(".swatch_main_wrap_in.frame.size li.only_element[data-curr='0']").html();
$(".swatch_main_wrap_in.frame.size li").removeClass('selected');
   var didx = parseInt($(".swatch_main_wrap_in.frame.size li.only_element[data-curr='0']").attr("data-index"));
    var curridx = parseInt($(".swatch_main_wrap_in.frame.size li.only_element[data-curr='0']").attr("data-curr"));
    $("variant-radios fieldset").eq(didx).find("input").eq(curridx).trigger("click");

$(".swatch_main_wrap_in.frame.size li.only_element[data-curr='0']").addClass('selected');
$(".swatch_main_wrap_in.frame.size li.init.only_element").html(get_value);
 
}else if(check_selected == 10){
$(".swatch_main_wrap_in.frame.size li").removeClass('hidden');

$(".swatch_main_wrap_in.frame.size li[data-curr='0']").addClass('hidden');
$(".swatch_main_wrap_in.frame.size li").addClass('only_element');
  var get_value = $(".swatch_main_wrap_in.frame.size li.only_element[data-curr='1']").html();
$(".swatch_main_wrap_in.frame.size li").removeClass('selected');
   var didx = parseInt($(".swatch_main_wrap_in.frame.size li.only_element[data-curr='1']").attr("data-index"));
    var curridx = parseInt($(".swatch_main_wrap_in.frame.size li.only_element[data-curr='1']").attr("data-curr"));
    $("variant-radios fieldset").eq(didx).find("input").eq(curridx).trigger("click");

$(".swatch_main_wrap_in.frame.size li.only_element[data-curr='1']").addClass('selected');
$(".swatch_main_wrap_in.frame.size li.init.only_element").html(get_value);
 
  }else{
$(".swatch_main_wrap_in.frame.size li").removeClass('hidden');
$(".swatch_main_wrap_in.frame.size li").removeClass('only_element');

}

      }
  

  

    if ($("body").hasClass("template-product") == true) {  

   $('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: false,
    speed: 400,   
      infinite: false,   
  asNavFor: '.slider-nav',
   prevArrow:"<img class='img_lft' src='https://cdn.shopify.com/s/files/1/0685/4662/5750/files/Left-Arrow.svg?v=1710839853'>",
  nextArrow:"<img class='img_rt' src='https://cdn.shopify.com/s/files/1/0685/4662/5750/files/Right-arrow.svg?v=1710839853'>",
   responsive: [
    {
      breakpoint: 767,
      settings: {
        prevArrow:"<img class='img_lft' src='https://cdn.shopify.com/s/files/1/0685/4662/5750/files/Left-Arrow-mob.svg?v=1710848084'>",
       nextArrow:"<img class='img_rt' src='https://cdn.shopify.com/s/files/1/0685/4662/5750/files/Right-Arrow-mob.svg?v=1710848084'>"
      },
    },
  ]   
    
});
$('.slider-nav').slick({
slidesToShow: 5,
slidesToScroll: 1,
asNavFor: '.slider-for',
dots: false,
arrows: false,
infinite: false,   
focusOnSelect: true,
draggable: false,
swipeToSlide: false,
touchMove: false,
swipe:false  
});

      
 
      setTimeout(function(){
         update_slider();        
        $(".template-product").css("opacity","1");       
      }, 1200);

   
  
   
      
      
var htmls = $(".swatches_custom.sl_boxes").html().trim();
if(htmls == ''){
    $(".swatches_custom.sl_boxes").remove();
}

var htmls = $(".swatches_custom.sl_colors").html().trim();
if(htmls == ''){
    $(".swatches_custom.sl_colors").remove();
}  
   var arrts = [];
$(".swatches_custom.sl_boxes h3").each(function() {
   var currren_hgt  = $(this).height();
   arrts.push(currren_hgt); 
});
Array.prototype.max = function() {
  return Math.max.apply(null, this);
};
$(".swatches_custom.sl_boxes h3").height(arrts.max());     
    }
  
$("table thead tr th").each(function(){
var cureentindex =  $(this).index();
var label =  $(this).html();  
 $(this).parents("table").find("tbody tr").each(function(){
   $(this).find("td").eq(cureentindex).attr("label",label)    
 });  
});
  
//
setTimeout(function() {
  $("#29375-text-7").attr("type", "date");
  $(".message.error").prev().hide();
  $(".g-container").css("opacity", "1");

  var Html = '<div class="globo-form-control layout-1-column custom_para"><label for="29375-text-12" class="classic-label globo-label"><span class="label-content" data-label="Comments">Comments</span><span></span></label><div class="globo-form-input"><textarea id="29375-text-12" data-type="textarea" class="classic-input" rows="3" name="text-12" placeholder=""></textarea></div></div>';
  $(Html).insertAfter(".globo-form-control.layout-1-column:last-child");

  var raq = getCookie('raq');  

  if (raq === '') {
    $(".emp-cnt").show();
  } else {
    try {
      var jsonobj = JSON.parse(raq);

      if (jsonobj.length === 0) {
        $(".emp-cnt").show();
      } else {
        var finalhtml = '';
        for (var i = 0; i < jsonobj.length; i++) {
          finalhtml += "Title - " + jsonobj[i]['ptitle'] + "||Sku - " + jsonobj[i]['sku'] + '||Quantity - ' + jsonobj[i]['quantity'];
          if (jsonobj.length !== i + 1) {
            finalhtml += '$$';
          }
        }
        $(".custom_para textarea").html(finalhtml);
      }
    } catch (e) {
      console.error("Failed to parse JSON: ", e);
      // Handle the error as needed, e.g., show an error message
    }
  }
}, 1300);


var arrts = [];
$(".product-coll .product-txt .pTtl").each(function() {
   var currren_hgt  = $(this).height();
   arrts.push(currren_hgt); 
});
Array.prototype.max = function() {
  return Math.max.apply(null, this);
};
console.log(arrts.max());  
$(".product-coll .product-txt .pTtl").height(arrts.max());  



// $('.owl-stage').slick({
//   dots: true,
//   infinite: true,
//   speed: 300,
//   arrows : true,
//   slidesToShow: 1,
//   adaptiveHeight: false
// });
  setTimeout(function(){  
$(".template-index").css("opacity","1");  
	   }, 100);  
  setTimeout(function(){ 
     $(".side_btn .banner-button").addClass("act_btn")   
	   }, 500);  

  
// $(".search-modal__form").submit();

$(".pg-documents .faq-btns .btn-warning img").attr("src","https://cdn.shopify.com/s/files/1/0685/4662/5750/files/Button-Arrow_eb83166b-56c7-43ae-9407-bd6c3fe033c4.svg?v=1710227119");

  
});
setInterval(function () {
  if($('.kl-private-reset-css-Xuajs1[aria-label="POPUP Form"]').length > 0){
$('.kl-private-reset-css-Xuajs1[aria-label="POPUP Form"]').parent().remove();
  }
  }, 1);

$(document).ready(function() {
    // Listen for click events on the accordion buttons
    $('.accordion-button').on('click', function() {
        // Get the corresponding accordion body
          $('.accordion-body .links-main iframe').remove();

        var accordionBody = $(this).closest('.accordion-item').find('.accordion-body');
        
        // Remove any existing iframes inside the accordion body
        accordionBody.find('iframe').remove();
        
        // Check if the accordion body contains the class 'stretch_rack_frame'
        if (accordionBody.find('.stretch_rack_frame').length) {
            // Append the iframe for 'stretch_rack_frame'
            accordionBody.find('.stretch_rack_frame').append('<iframe src="https://sarisinfrastructure-embedded.partcommunity.com/3d-cad-models/?info=saris_infrastructure/stretchrack_series/str_rack_asmtab.prj" frameborder="1" scrolling="no" width="980" height="600"></iframe>');
        }

        // Check if the accordion body contains the class 'stack_rack_frame'
        if (accordionBody.find('.stack_rack_frame').length) {
            // Append the iframe for 'stack_rack_frame'
            accordionBody.find('.stack_rack_frame').append('<iframe src="https://sarisinfrastructure-embedded.partcommunity.com/3d-cad-models/?info=saris_infrastructure/stackrack_series/sta_rack_asmtab.prj" frameborder="1" scrolling="no" width="980" height="600"></iframe>');
        }
        if (accordionBody.find('.ver_rack_frame').length) {
            // Append the iframe for 'stack_rack_frame'
            accordionBody.find('.ver_rack_frame').append('<iframe src="https://sarisinfrastructure-embedded.partcommunity.com/3d-cad-models/vertical-racks-floor-mount-saris-saris-infrastructure?info=saris_infrastructure%2Fverticalrack_series%2Fvr_floor_mount_asmtab.prj&cwid=8719" frameborder="1" scrolling="no" width="980" height="600"></iframe>');
        }
        if (accordionBody.find('.ebike_frame').length) {
            // Append the iframe for 'stack_rack_frame'
            accordionBody.find('.ebike_frame').append('<iframe src="https://sarisinfrastructure-embedded.partcommunity.com/3d-cad-models/ebike-charging-stations-saris-saris-infrastructure?info=saris_infrastructure%2Febike_cs%2Febike_cs_asmtab.prj&amp;cwid=2070" frameborder="1" scrolling="no" width="980" height="600"></iframe>');
        }
    });
var get_id = $("input.product-variant-id").val();
      var get_desc = $(".variant_description[data-id="+get_id+"]").html();
      var get_specs = $(".variant_specs[data-id="+get_id+"]").html();
    //  var get_features = $(".variant_features[data-id="+get_id+"]").html();

      $(".product__description.rte").html(get_desc);
$(".accordion-item.specs_acc .accordion-collapse.collapse").html(get_specs);
});







// Frequently Bought Product ( Addon product ) js on product page desktop

$(document).ready(function() {
 
  // Handle Add to Cart functionality
  $('#add-to-cart-btn').on('click', function(e) {
    e.preventDefault();
   
    
    // Create an array to hold the products that will be added to the cart
    let productsToAdd = [];

    // Loop through the checked checkboxes to gather the product ids and their variants
    $('.addon-product-id:checked').each(function() {
      const variantId = $(this).val();
      productsToAdd.push({
        id: variantId,
        quantity: 1
      });
    });

    // Send the products to the Shopify cart using AJAX
    if (productsToAdd.length > 0) {
      // Perform the AJAX request to add products to the cart
      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        data: {
          items: productsToAdd // Pass the array of products to add
        },
        dataType: 'json',
        success: function(data) {
          //console.log('Added to cart:', data);
          // Optionally, update the cart UI here (e.g., show a cart popup)
          
         //$('.successMessage').text('Product successfully added to your cart!').fadeIn().delay(3000).fadeOut();
          
            
            $.ajax({
                type: 'GET',
                url: '/cart.js',
                cache: false,
                dataType: 'json',
                success: function(cart) {
                  //var viid = $(".product-form form input[name='id']").val();
                  //console.log(viid);
                  var nehtml = '';
                  for (var i = 0; i < cart.items.length; i++) {
                    // if(cart.items[i].id == viid){
                      var imgs = cart.items[i].image;
                      var ttl = cart.items[i].title;
                       nehtml += '<div id="shopify-section-cart-notification-product" class="shopify-section"><div class="cart-item"><div class="cart-notification-product__image global-media-settings"><img src="'+imgs+'" alt="" width="70" height="70" loading="lazy"></div><div><h3 class="cart-notification-product__name h4">'+ttl+'</h3><dl></dl></div></div></div>';
        
                    // }
                  }
                  
                  $("#cart-notification-product").html(nehtml);
                  $("#cart-notification").css("opacity","1");
                    var url = window.location.href;
                    var result = url.includes("deluxe-public-work-stand");
                    if(result == true){
                    var counter = 0;
                  for (var i = 0; i < cart.items.length; i++) {
                     if(cart.items[i].product_id == 8296694808790){
                       counter +=cart.items[i].quantity;
                     }
                    }
                      $(".cnt-prd").attr("data-number",counter);
                   if(counter > 2){
                     $(".cnt-prd").show();
                     $(".product-form__submit").addClass("disabled-btn");
                   }
                   else{
                  $(".cnt-prd").hide();
                  $(".product-form__submit").removeClass("disabled-btn");
                   }   
                    }
                  var chg_ln = $(".mns-deluxe-public-work-stand").length;
                  if(chg_ln > 0 ){
                     var counter = 0;
                  for (var i = 0; i < cart.items.length; i++) {
                     if(cart.items[i].product_id == 8296694808790){
                       counter +=cart.items[i].quantity;
                     }
                    }
                    if(counter > 2){
                     $(".cnt-prd").show();
                     $(".mns-deluxe-public-work-stand").addClass("hidden-product-deluxe-public-work-stand");
                   }
                   else{
                  $(".cnt-prd").hide();
                  $(".mns-deluxe-public-work-stand").removeClass("hidden-product-deluxe-public-work-stand");
                   }   
        
                  }
        
                  setTimeout(function(){
                    $('#cart-notification').addClass('active');
                  }, 1000);
        
                }
            });

             $.ajax({
                type: 'GET',
                url: '/',
                cache: false,
                dataType: 'html',
                success: function(cart) {
                  var fhtml = $(cart).find(".cart_counter").html();
                  $(".cart_counter").html(fhtml);
                    var fhtml = $(cart).find("#cart-icon-bubble").html();
                  $("#cart-icon-bubble").html(fhtml);
                }
            });
            if (this.header) this.header.reveal();
            this.open();


          // $('.successMessage').text('Product successfully added to your cart!').fadeIn().delay(3000).fadeOut();

         //setTimeout(function(){
             //renderContents(parsedState);
              //location.href = '/cart';
              //$('#cart-notification').addClass('active');
         // }, 4000);
          
          //onSubmitHandler();
          
        },
        error: function(error) {
          console.error('Error adding to cart:', error);
        }
      });
    }
  });
});


// setInterval(function () {
// var existcls  = $(".slider-for .slick-active .video_slide").length;
// if(existcls > 0){
// document.querySelector(".slider-for .slick-active .video_slide video").play();
// }
// else{
// document.querySelector(".slider-for .video_slide video").pause();
// }
// }, 200);  


//product page vedio play
  function playProductVideo(wrapper) {
    const poster = wrapper.querySelector('.video-poster');
    const button = wrapper.querySelector('.play-button');
    const video = wrapper.querySelector('video');



    poster.style.display = 'none';
    button.style.display = 'none';
    video.classList.remove('hidden');
    video.play();
    wrapper.classList.add('playing');
  }

